import axios from 'axios';

const PrimaClient = axios.create({
    baseURL: process.env.VUE_APP_PRIMA_API,
    headers: {
        'Ocp-apim-subscription-key': process.env.VUE_APP_API_MANAGEMENT_KEY
      }
});

export default PrimaClient;